import App from './writers/App.svelte';

const app = new App({
	target: document.getElementById('svelte-app'),
	props: {
		url: '/_writers.php'
	}
});

export default app;